const e = () => {
  if (typeof window < "u")
    return document.getElementById("__next");
};
export {
  e as getRootElement
};
